import { Uniform } from './Uniform';

export class UniformFloat extends Uniform {

    loadFloat(value: number){
        if(this.location){
            this.gl.uniform1f(this.location, value);
        }
    }
}